"use strict";
import {http} from '../../core';
import Config from "../../app.config";
const RequestService = http.create();
const RequestbaseURL = http.create({baseURL:Config.BASEURL});
export default {
    // 发布事件列表
    getList: function (params) {
        return RequestService.get("deploy/list", params);
    },
    // 新增发布
    addDeploy: function (params) {
          return RequestService.post('deploy/add',params);
        // return Promise.resolve()
    },
    // 修改发布
    updateDeploy: function (params) {
          return RequestService.post('deploy/update',params);
        // return Promise.resolve()
    },
    // 发布详情
    detail: function (params) {
        // console.log(params,'发布详情');
        return RequestService.get("deploy/detail", params);
    },
    deteleDeploy:function(params){
        return RequestService.post('deploy/delete',params)
    },
    // 繁忙度统计---组繁忙度
    busynessGroup:function (departmentId) {
        return RequestService.get("organization/group/busyness",{ departmentId:departmentId })
    },
    // 繁忙度统计---人员繁忙度
    busynessUser:function (userId) {
        return RequestbaseURL.get("itsm/v2/organization/user/busyness",{ internalUserid:userId })
    },
    //新增时获取发布模板
    getDepTemplateList(params){
        return RequestService.get('case/template/list',params)
    },
    //选择模板后请求模板详情
    getDepTemplate(params){
        return RequestService.get('case/template/describe',{id:params})
    },
    // 根据关键字获取知识列表
    getKnowledgeList:function (params) {
        return RequestService.get("knowledge/query",params);
        // return Promise.resolve([
        //     { id:1 ,}
        // ])
    },
    // 获取申请人列表
    getApplicantList: function (params) {
        return Promise.resolve({
            list: [
                {id: 1},
                {id: 2},
                {id: 3}
            ],
            total: 20
        })
    },

}


